// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uGWli","field":"styles_field__12oA-","fieldCol":"styles_fieldCol__vCPBH","diffCol":"styles_diffCol__2wFU0","diff":"styles_diff__2x84r"};